export const sectionObjOne = {
    id: 'services',
    type: 1,
    lightBg: false,
    lightText: true,
    lighTextDesc: true,
    title1: 'Industrial Machining',
    title2: 'Automation',
    title3: 'Mechanical Design',
    title4: 'Inductrial Facilities and Structural Welding',
    title5: 'Industrial Workbenches Solutions',
    title6: 'Laser Cutting',
    title7: '3D Printing',
    title8: 'Training and Consulting',
    p1: 'We have conventional and CNC machines to manufacture tools and fixtures using different materials such as high and low carbon steels, stainless steels, aluminum, delrin, nylon, polycarbonate, aluminum and steel profiles, G10, Peek and Ultem, etc.',
    p2: 'We develop manual and automated systems according to the needs and budget of the client. Programming of the most commercial brands of PLC and Servo Motors, instrumentation and applications with LabView. Electrical and pneumatic integration.',
    p3: 'We have SolidWorks 2022 licenses and powerful computers to deliver solutions quickly, as well as specialized design engineers, with considerable experience in automation, mechanics and engineering, certified in SolidWorks at the professional and expert level (CSWP and CSWE).',
    p4: 'Construction of structures for machinery and equipment, electrical and lighting installations, industrial plumbing, grounding systems, energy saving studies, machinery and equipment installations, as well as industrial maintenance.',
    p5: 'We manufacture workstations, tables and tool trolleys using welding, aluminum and steel profiles or pipes (Creform) with LED lamps, drawers, rollers, etc. with covered wood, laminate or plastic covers.',
    p6: 'We offer you the laser cutting service using CO2 and NO2 for carbon steel, stainless steel and aluminum, among others materials.',
    p7: 'We provide SLA and FDM 3D printing technology, using materials such as PLA, ABS, PTEG, Nylon and Resin.',
    p8: 'We have SolidWorks and CNC courses, for groups and individuals, open to the public, companies or private groups, with basic, intermediate and advanced levels.',
    Icon1: require('../../img/icon/svg-1.svg').default,
    Icon2: require('../../img/icon/svg-2.svg').default,
    Icon3: require('../../img/icon/svg-3.svg').default,
    Icon4: require('../../img/icon/svg-4.svg').default,
    Icon5: require('../../img/icon/svg-5.svg').default,
    Icon6: require('../../img/icon/svg-6.svg').default,
    Icon7: require('../../img/icon/svg-7.svg').default,
    Icon8: require('../../img/icon/svg-8.svg').default,
    alt: 'Icon',
    dark: false,
    primary: true,
    darkText: false
};
